/**
 * @voltxampere/engine — Independent current source DC stamp
 *
 * Sign convention: the `pos` terminal is the OUT terminal — the
 * source delivers current `I` *into* the node attached to `pos`,
 * and pulls the same current *out* of `neg`. This matches the
 * intuitive "arrow points the way current flows" reading of a
 * current source schematic, and matches the Sprint 5 prompt's test
 * fixture (1 mA into a 1 kΩ → 1 V at the resistor node).
 *
 * Stamp:
 *   rhs[pos] += I * sourceScale,
 *   rhs[neg] -= I * sourceScale.
 *
 * `sourceScale` implements SPECS §3.7 source stepping. Either
 * terminal may be ground; we guard the writes manually because the
 * RHS isn't routed through `addY`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { defineDCStamp } from "../definition.js";
import { getTerminalNetId, getNumericParam } from "../terminal-utils.js";
export const currentSourceDCStamp = (ctx, component) => {
    const i = getNumericParam(component, "current");
    const pos = ctx.nodeIndex(getTerminalNetId(component, "pos"));
    const neg = ctx.nodeIndex(getTerminalNetId(component, "neg"));
    const scaled = i * ctx.sourceScale;
    if (pos >= 0)
        ctx.rhs[pos] = (ctx.rhs[pos] ?? 0) + scaled;
    if (neg >= 0)
        ctx.rhs[neg] = (ctx.rhs[neg] ?? 0) - scaled;
};
/** Pure RHS contribution — no augmented MNA rows. */
export const currentSourceDCStampDefinition = defineDCStamp("current-source", currentSourceDCStamp, []);
//# sourceMappingURL=current-source.js.map